import { render } from "./Guide.vue?vue&type=template&id=f422a946&scoped=true&ts=true&lang=pug"
import script from "./Guide.vue?vue&type=script&lang=ts"
export * from "./Guide.vue?vue&type=script&lang=ts"

import "./Guide.vue?vue&type=style&index=0&id=f422a946&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./Guide.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/es/components/guide.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fviews%2FGuide%2FGuide.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f422a946"]])

export default __exports__